import type React from 'react'

type Props = {
  disabled?: boolean
}

const NeutralFrame: React.FC<Props> = ({ disabled }) => (
  <svg
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.7"
      y="0.7"
      width="62.6"
      height="46.6"
      rx="11.3"
      stroke={disabled ? '#ACBDD3' : '#2F7FEF'}
      strokeWidth="1.4"
      strokeOpacity={disabled ? 0.75 : 1}
    />
  </svg>
)

export default NeutralFrame
